<template>
  <div class="settings-gtm">
    <b-form>
      <b-form-group label="Google Tag Manager (GTM) Settings" label-class="font-weight-bold">
        <b-form-group label="GTM Container ID:" description="e.g., GTM-TVRTTMM">
          <b-form-input v-model="gtmId" placeholder="GTM-XXXXXXX"></b-form-input>
        </b-form-group>

        <b-form-group label="Data Layer Name:" description="Default: dataLayer">
          <b-form-input v-model="dataLayerName" placeholder="dataLayer"></b-form-input>
        </b-form-group>

        <b-form-group class="mt-3">
          <b-button variant="primary" @click="initializeGTM">
            <b-icon-download></b-icon-download> Initialize GTM
          </b-button>
        </b-form-group>

        <b-alert v-if="gtmInitialized" variant="success" show class="mt-3">
          <strong>GTM Initialized!</strong>
          <div>Container ID: {{ gtmId }}</div>
          <div>Data Layer: {{ dataLayerName }}</div>
        </b-alert>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { showEventToast } from '../utils/eventToast';

export default {
  name: 'SettingsGTM',
  data() {
    return {
      gtmId: 'GTM-TVRTTMM',
      dataLayerName: 'dataLayer',
      gtmInitialized: false
    };
  },
  methods: {
    initializeGTM() {
      this.gtmInitialized = true;
      // Inject GTM script into the page
      this.injectGTMScript();
      this.$gtag.event('GTM_Initialized', {
        gtm_id: this.gtmId,
        data_layer_name: this.dataLayerName
      });
      // Emit event to notify parent components
      this.$root.$emit('gtm-initialized');
      
      // Show toast with event details
      showEventToast(this, 'GTM_Initialized', {
        event: 'GTM_Initialized',
        gtm_id: this.gtmId,
        data_layer_name: this.dataLayerName
      }, '⚙️', 'success', {
        gtm_id: this.gtmId,
        data_layer_name: this.dataLayerName,
        timestamp: new Date().toISOString()
      });
    },
    injectGTMScript() {
      // Create Google Tag Manager script
      const gtmScript = document.createElement('script');
      gtmScript.async = true;
      gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${this.gtmId}`;
      
      // Initialize data layer
      window[this.dataLayerName] = window[this.dataLayerName] || [];
      window[this.dataLayerName].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });

      // Inject script into head
      document.head.appendChild(gtmScript);

      // Add noscript fallback
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${this.gtmId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);

      console.log(`GTM initialized with ID: ${this.gtmId}, DataLayer: ${this.dataLayerName}`);
    }
  }
};
</script>

<style scoped>
.settings-gtm {
  padding: 20px;
}
</style>
